"use client";
import { useState } from "react";
import Plus from "@/assets/icon/plus.svg"
import { EventNewSelectEventModal } from "./EventNewSelectEventModal";
import Button from "../Button";

export function EventNewSelectEventModalMobileNavButton({teamId, canCreateClubEvent, canCreatePersonEvent, canCreateTeamEvent}: {teamId?: string, canCreateClubEvent: boolean, canCreateTeamEvent: boolean, canCreatePersonEvent: boolean}) {
  const [isModalOpen, setModalOpen] = useState(false);

  function handleCloseModal() {
    setModalOpen(false);
  }

  return <>
    <Button className="" color="link-secondary" onClick={() => setModalOpen(true)}><Plus className="text-lg sm:text-base sm:mr-blank" /><span className="hidden sm:block">Neuer Termin</span></Button>
    <EventNewSelectEventModal isOpen={isModalOpen} onRequestClose={handleCloseModal} teamId={teamId} canCreateClubEvent={canCreateClubEvent} canCreateTeamEvent={canCreateTeamEvent} canCreatePersonEvent={canCreatePersonEvent}/>
  </>
}
